import React, { useEffect, useMemo, useState } from 'react';
import { BarChart2Icon, UserPlusIcon, DollarSignIcon, TrendingUpIcon, UsersIcon, GlobeIcon, FileTextIcon, BriefcaseIcon, ActivityIcon, LayoutDashboardIcon, SearchIcon, FilterIcon, RefreshCwIcon, CalendarIcon, DownloadIcon, ChevronDownIcon, MapIcon, PieChartIcon, LineChartIcon, BellIcon, ArrowUpIcon, ArrowDownIcon, CheckCircleIcon, XCircleIcon, AlertTriangleIcon, ZapIcon, ListIcon, GridIcon, EyeIcon, ClipboardCheckIcon, HeartIcon, BuildingIcon, HelpCircleIcon, StarIcon, BadgeIcon, LayersIcon, PercentIcon, ClockIcon, TargetIcon, FlagIcon, HashIcon, TagIcon, ShieldIcon, ThumbsUpIcon, MessageSquareIcon, LinkIcon, BarChart3Icon, CheckIcon, XIcon } from 'lucide-react';
import { LeadInsightsOverview } from '../components/dashboard/alternative/LeadInsightsOverview';
// Mock data for Lead Insights
const mockLeadData = {
  totalLeads: 1245,
  qualifiedLeads: 876,
  conversionRate: 12.4,
  avgResponseTime: 4.2,
  leadsBySource: [{
    source: 'Website',
    count: 540,
    percentage: 43
  }, {
    source: 'Social Media',
    count: 320,
    percentage: 26
  }, {
    source: 'Trade Shows',
    count: 210,
    percentage: 17
  }, {
    source: 'Referrals',
    count: 175,
    percentage: 14
  }],
  leadsByStatus: [{
    status: 'New',
    count: 320,
    percentage: 26
  }, {
    status: 'Contacted',
    count: 410,
    percentage: 33
  }, {
    status: 'Qualified',
    count: 290,
    percentage: 23
  }, {
    status: 'Unqualified',
    count: 225,
    percentage: 18
  }],
  leadsByRegion: [{
    region: 'North America',
    count: 480,
    percentage: 39
  }, {
    region: 'Europe',
    count: 350,
    percentage: 28
  }, {
    region: 'Asia Pacific',
    count: 240,
    percentage: 19
  }, {
    region: 'Latin America',
    count: 175,
    percentage: 14
  }]
};
// Mock data for Sales Performance
const mockSalesData = {
  totalQuotes: 876,
  activeQuotes: 320,
  expiredQuotes: 156,
  wonQuotes: 245,
  lostQuotes: 155,
  newCustomers: 124,
  interactions: 2345,
  conversionRate: 28.5,
  totalQuotedValue: 12500000,
  totalClosedValue: 3750000,
  averageQuoteTicket: 14269,
  averageOrderTicket: 15306,
  openQuotesValue: 8750000,
  avgQuoteToOrderTime: 14.3,
  avgDesignToQuoteTime: 5.2,
  avgInactivityTime: 8.5,
  designToQuoteConversion: 65,
  quoteToOrderConversion: 28,
  designToOrderConversion: 18,
  newCustomerConversion: 22,
  recurringCustomerConversion: 38,
  strategicCustomerConversion: 45,
  salesManagerPerformance: [{
    id: 1,
    name: 'John Smith',
    region: 'North America',
    quotes: 145,
    wonQuotes: 48,
    openQuotes: 65,
    lostQuotes: 32,
    quotedValue: 2100000,
    closedValue: 750000,
    newCustomers: 22,
    interactions: 456,
    avgCycleTime: 12.5,
    conversionRate: 33.1
  }, {
    id: 2,
    name: 'Maria Rodriguez',
    region: 'Latin America',
    quotes: 132,
    wonQuotes: 45,
    openQuotes: 55,
    lostQuotes: 32,
    quotedValue: 1800000,
    closedValue: 680000,
    newCustomers: 18,
    interactions: 390,
    avgCycleTime: 11.2,
    conversionRate: 34.1
  }, {
    id: 3,
    name: 'Robert Chen',
    region: 'Asia Pacific',
    quotes: 118,
    wonQuotes: 32,
    openQuotes: 58,
    lostQuotes: 28,
    quotedValue: 1650000,
    closedValue: 520000,
    newCustomers: 15,
    interactions: 345,
    avgCycleTime: 15.8,
    conversionRate: 27.1
  }, {
    id: 4,
    name: 'Emma Johnson',
    region: 'Europe',
    quotes: 156,
    wonQuotes: 52,
    openQuotes: 72,
    lostQuotes: 32,
    quotedValue: 2250000,
    closedValue: 820000,
    newCustomers: 24,
    interactions: 480,
    avgCycleTime: 13.4,
    conversionRate: 33.3
  }, {
    id: 5,
    name: 'Ahmed Hassan',
    region: 'Middle East',
    quotes: 98,
    wonQuotes: 24,
    openQuotes: 45,
    lostQuotes: 29,
    quotedValue: 1350000,
    closedValue: 410000,
    newCustomers: 12,
    interactions: 265,
    avgCycleTime: 16.2,
    conversionRate: 24.5
  }, {
    id: 6,
    name: 'Sofia Mendoza',
    region: 'Latin America',
    quotes: 112,
    wonQuotes: 34,
    openQuotes: 48,
    lostQuotes: 30,
    quotedValue: 1580000,
    closedValue: 540000,
    newCustomers: 16,
    interactions: 320,
    avgCycleTime: 14.7,
    conversionRate: 30.4
  }, {
    id: 7,
    name: 'James Wilson',
    region: 'North America',
    quotes: 115,
    wonQuotes: 38,
    openQuotes: 52,
    lostQuotes: 25,
    quotedValue: 1750000,
    closedValue: 630000,
    newCustomers: 17,
    interactions: 345,
    avgCycleTime: 12.8,
    conversionRate: 33.0
  }],
  regionPerformance: [{
    region: 'Norteamérica',
    quotes: 320,
    wonQuotes: 110,
    conversionRate: 34.4,
    avgCycleTime: 12.5
  }, {
    region: 'Europa',
    quotes: 280,
    wonQuotes: 85,
    conversionRate: 30.4,
    avgCycleTime: 14.2
  }, {
    region: 'Asia Pacífico',
    quotes: 145,
    wonQuotes: 38,
    conversionRate: 26.2,
    avgCycleTime: 16.8
  }, {
    region: 'Latinoamérica',
    quotes: 210,
    wonQuotes: 68,
    conversionRate: 32.4,
    avgCycleTime: 11.5
  }, {
    region: 'Medio Oriente',
    quotes: 95,
    wonQuotes: 22,
    conversionRate: 23.2,
    avgCycleTime: 18.3
  }],
  quotesByProduct: [{
    product: 'Center Pivots',
    count: 320,
    percentage: 36.5
  }, {
    product: 'Linear Systems',
    count: 245,
    percentage: 28.0
  }, {
    product: 'Drip Irrigation',
    count: 180,
    percentage: 20.5
  }, {
    product: 'Micro Sprinklers',
    count: 85,
    percentage: 9.7
  }, {
    product: 'Other Products',
    count: 46,
    percentage: 5.3
  }],
  salesTrend: [{
    month: 'Jan',
    quotes: 120,
    orders: 35
  }, {
    month: 'Feb',
    quotes: 145,
    orders: 42
  }, {
    month: 'Mar',
    quotes: 165,
    orders: 48
  }, {
    month: 'Apr',
    quotes: 155,
    orders: 45
  }, {
    month: 'May',
    quotes: 170,
    orders: 52
  }, {
    month: 'Jun',
    quotes: 190,
    orders: 58
  }, {
    month: 'Jul',
    quotes: 175,
    orders: 55
  }]
};
// Mock data for Customer Analytics
const mockCustomerData = {
  totalCustomers: 1450,
  activeCustomers: 980,
  newCustomersThisMonth: 85,
  customerRetentionRate: 78.5,
  totalDealers: 120,
  activeDealers: 98,
  customerLifetimeValue: 45600,
  customerAcquisitionCost: 1250,
  customersByRegion: [{
    region: 'North America',
    count: 480,
    percentage: 33.1
  }, {
    region: 'Europe',
    count: 350,
    percentage: 24.1
  }, {
    region: 'Asia Pacific',
    count: 320,
    percentage: 22.1
  }, {
    region: 'Latin America',
    count: 210,
    percentage: 14.5
  }, {
    region: 'Middle East',
    count: 90,
    percentage: 6.2
  }],
  customersByType: [{
    type: 'Dealers',
    count: 120,
    percentage: 8.3
  }, {
    type: 'End Customers',
    count: 850,
    percentage: 58.6
  }, {
    type: 'Distributors',
    count: 65,
    percentage: 4.5
  }, {
    type: 'Contractors',
    count: 415,
    percentage: 28.6
  }]
};
// Mock data for Market Insights
const mockMarketData = {
  marketShareByRegion: [{
    region: 'North America',
    share: 28.5,
    trend: 'up',
    change: 2.3
  }, {
    region: 'Europe',
    share: 22.4,
    trend: 'up',
    change: 1.5
  }, {
    region: 'Asia Pacific',
    share: 18.2,
    trend: 'up',
    change: 3.2
  }, {
    region: 'Latin America',
    share: 32.6,
    trend: 'up',
    change: 4.1
  }, {
    region: 'Middle East',
    share: 15.8,
    trend: 'down',
    change: 1.2
  }],
  competitorComparison: [{
    competitor: 'Our Company',
    marketShare: 24.5,
    growthRate: 3.2
  }, {
    competitor: 'Competitor A',
    marketShare: 18.2,
    growthRate: 1.8
  }, {
    competitor: 'Competitor B',
    marketShare: 15.6,
    growthRate: 2.1
  }, {
    competitor: 'Competitor C',
    marketShare: 12.3,
    growthRate: -0.5
  }, {
    competitor: 'Others',
    marketShare: 29.4,
    growthRate: 0.3
  }],
  productMarketGrowth: [{
    product: 'Center Pivots',
    growth: 4.5,
    marketSize: 850
  }, {
    product: 'Linear Systems',
    growth: 3.2,
    marketSize: 620
  }, {
    product: 'Drip Irrigation',
    growth: 5.8,
    marketSize: 780
  }, {
    product: 'Micro Sprinklers',
    growth: 2.1,
    marketSize: 340
  }]
};
// Mock data for Revenue Intelligence
const mockRevenueData = {
  totalRevenue: 12500000,
  revenueGrowth: 8.5,
  forecastRevenue: 14200000,
  revenueByProduct: [{
    product: 'Center Pivots',
    revenue: 5250000,
    percentage: 42
  }, {
    product: 'Linear Systems',
    revenue: 3125000,
    percentage: 25
  }, {
    product: 'Drip Irrigation',
    revenue: 2500000,
    percentage: 20
  }, {
    product: 'Micro Sprinklers',
    revenue: 1000000,
    percentage: 8
  }, {
    product: 'Other Products',
    revenue: 625000,
    percentage: 5
  }],
  revenueByRegion: [{
    region: 'North America',
    revenue: 4375000,
    percentage: 35
  }, {
    region: 'Europe',
    revenue: 3125000,
    percentage: 25
  }, {
    region: 'Asia Pacific',
    revenue: 2500000,
    percentage: 20
  }, {
    region: 'Latin America',
    revenue: 1875000,
    percentage: 15
  }, {
    region: 'Middle East',
    revenue: 625000,
    percentage: 5
  }],
  monthlyRevenue: [{
    month: 'Jan',
    revenue: 980000
  }, {
    month: 'Feb',
    revenue: 1050000
  }, {
    month: 'Mar',
    revenue: 1120000
  }, {
    month: 'Apr',
    revenue: 1080000
  }, {
    month: 'May',
    revenue: 1150000
  }, {
    month: 'Jun',
    revenue: 1220000
  }, {
    month: 'Jul',
    revenue: 1180000
  }]
};
// Mock sales managers data
const mockSalesManagers = [{
  id: 1,
  name: 'John Smith',
  region: 'North America',
  avatar: 'JS',
  color: 'bg-blue-500'
}, {
  id: 2,
  name: 'Maria Rodriguez',
  region: 'Latin America',
  avatar: 'MR',
  color: 'bg-green-500'
}, {
  id: 3,
  name: 'Robert Chen',
  region: 'Asia Pacific',
  avatar: 'RC',
  color: 'bg-purple-500'
}, {
  id: 4,
  name: 'Emma Johnson',
  region: 'Europe',
  avatar: 'EJ',
  color: 'bg-amber-500'
}, {
  id: 5,
  name: 'Ahmed Hassan',
  region: 'Middle East',
  avatar: 'AH',
  color: 'bg-red-500'
}, {
  id: 6,
  name: 'Sofia Mendoza',
  region: 'Latin America',
  avatar: 'SM',
  color: 'bg-indigo-500'
}, {
  id: 7,
  name: 'James Wilson',
  region: 'North America',
  avatar: 'JW',
  color: 'bg-teal-500'
}];
// NavButton component
function NavButton({
  icon,
  label,
  active,
  onClick
}) {
  return <button className={`flex items-center px-4 py-2 text-sm ${active ? 'text-white bg-blue-800/50 border-b-2 border-blue-500' : 'text-blue-300 hover:text-white hover:bg-blue-800/30'} transition-colors`} onClick={onClick} data-id="element-7417" data-mp="29gi1jsspcjdc">
      <span className="mr-2" data-id="element-7418" data-mp="2ne6m0ziuxohv">{icon}</span>
      {label}
    </button>;
}
export function BusinessIntelligencePage() {
  const [activeSection, setActiveSection] = useState('lead-insights');
  const [searchQuery, setSearchQuery] = useState('');
  const handleSearchChange = e => {
    setSearchQuery(e.target.value);
  };
  return <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-950" data-id="element-7419" data-mp="3ku2k8145ahdc">
      {/* Header */}
      <div className="relative z-10 flex items-center justify-between p-6 border-b border-blue-800/30" data-id="element-7420" data-mp="3u7b7tqus32eq">
        <div className="flex items-center" data-id="element-7421" data-mp="3q5zo21yl5beg">
          <div className="p-2 mr-3 bg-gradient-to-r from-purple-600 to-blue-600 rounded-lg flex items-center justify-center" data-id="element-7422" data-mp="3q4y9vom9w8si">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/eJcyBj2puhjmA95iiZVfaB/cyborg.svg" alt="Business Intelligence" className="w-5 h-5 filter brightness-0 invert" data-id="element-7423" data-mp="2t6v9lygjiwl" />
          </div>
          <h1 className="text-2xl font-bold text-white" data-id="element-7424" data-mp="378ey0rk346s9">
            Business Intelligence
          </h1>
        </div>
        <div className="flex items-center space-x-4" data-id="element-7425" data-mp="3l8pp9vpb3ndy">
          <div className="relative" data-id="element-7426" data-mp="3g8l966sb8uo9">
            <input type="text" placeholder="Search analytics..." value={searchQuery} onChange={handleSearchChange} className="pl-10 pr-4 py-2 bg-blue-900/30 border border-blue-800/30 rounded-lg text-white placeholder-blue-300 w-64 focus:outline-none focus:ring-2 focus:ring-blue-500/50" data-id="element-7427" data-mp="3g7jwxyzk624y" />
            <SearchIcon className="absolute left-3 top-2.5 text-blue-300" size={18} data-id="element-7428" data-mp="13jtrdv81t62n" />
            {searchQuery && <button onClick={() => setSearchQuery('')} className="absolute right-3 top-2.5 text-blue-300 hover:text-white" data-id="element-7429" data-mp="17jvw6d92yfm5">
                <XIcon size={16} data-id="element-7430" data-mp="1ck9swz58e34v" />
              </button>}
          </div>
          <button className="flex items-center px-4 py-2 bg-blue-800/30 hover:bg-blue-800/50 rounded-lg text-blue-200 border border-blue-700/30 transition-colors" data-id="element-7431" data-mp="1hj376tscdy63">
            <CalendarIcon size={18} className="mr-2" data-id="element-7432" data-mp="jt8bere2fvi6" />
            Last 30 Days
            <ChevronDownIcon size={16} className="ml-2" data-id="element-7433" data-mp="os31meed4mcb" />
          </button>
          <button className="flex items-center px-4 py-2 bg-blue-800/30 hover:bg-blue-800/50 rounded-lg text-blue-200 border border-blue-700/30 transition-colors" data-id="element-7434" data-mp="tsh1381wenyq">
            <DownloadIcon size={18} className="mr-2" data-id="element-7435" data-mp="1539zqkvsmmj" />
            Export
          </button>
          <div className="relative" data-id="element-7436" data-mp="63el04mwx36c">
            <BellIcon size={20} className="text-blue-300 hover:text-white cursor-pointer transition-colors" data-id="element-7437" data-mp="62d77seii2kx" />
            <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full text-xs flex items-center justify-center text-white" data-id="element-7438" data-mp="3up18lurmy2r9">
              3
            </span>
          </div>
        </div>
      </div>
      {/* Navigation Tabs */}
      <div className="flex px-6 py-2 overflow-x-auto border-b border-blue-800/30" data-id="element-7439" data-mp="3fsitvzkbt0ne">
        <NavButton icon={<UserPlusIcon size={18} data-id="element-7441" data-mp="3bqf5kack61kp" />} label="Lead Insights" active={activeSection === 'lead-insights'} onClick={() => setActiveSection('lead-insights')} data-id="element-7440" data-mp="3fumti5b6zdhv" />
        <NavButton icon={<TrendingUpIcon size={18} data-id="element-7443" data-mp="36xvsrflp3agy" />} label="Sales Performance" active={activeSection === 'sales-performance'} onClick={() => setActiveSection('sales-performance')} data-id="element-7442" data-mp="36ydz5522n52l" />
        <NavButton icon={<UsersIcon size={18} data-id="element-7445" data-mp="2x3c4xusxvct5" />} label="Customer Analytics" active={activeSection === 'customer-analytics'} onClick={() => setActiveSection('customer-analytics')} data-id="element-7444" data-mp="2x33t868jydjj" />
        <NavButton icon={<GlobeIcon size={18} data-id="element-7447" data-mp="2o2e23fu8lbc5" />} label="Market Insights" active={activeSection === 'market-insights'} onClick={() => setActiveSection('market-insights')} data-id="element-7446" data-mp="2o0ulfo4o4y9u" />
        <NavButton icon={<FileTextIcon size={18} data-id="element-7449" data-mp="3hrd3z2a65ygp" />} label="Quote Intelligence" active={activeSection === 'quote-intelligence'} onClick={() => setActiveSection('quote-intelligence')} data-id="element-7448" data-mp="3hqtum9yl4iea" />
        <NavButton icon={<DollarSignIcon size={18} data-id="element-7451" data-mp="380s8hnpsla20" />} label="Revenue Intelligence" active={activeSection === 'revenue-intelligence'} onClick={() => setActiveSection('revenue-intelligence')} data-id="element-7450" data-mp="33xm46lm8psy6" />
        <NavButton icon={<ActivityIcon size={18} data-id="element-7453" data-mp="2z0c8wpc66n2f" />} label="Engagement" active={activeSection === 'engagement'} onClick={() => setActiveSection('engagement')} data-id="element-7452" data-mp="2u3byy3c79061" />
        <NavButton icon={<LayoutDashboardIcon size={18} data-id="element-7455" data-mp="2l25ks0x0w1fy" />} label="Executive Insights" active={activeSection === 'executive-insights'} onClick={() => setActiveSection('executive-insights')} data-id="element-7454" data-mp="2l1w26yeb4wka" />
      </div>
      {/* Main Content */}
      <div className="p-6" data-id="element-7456" data-mp="j73h136xj9l8">
        {activeSection === 'lead-insights' && <LeadInsightsSection data={mockLeadData} searchQuery={searchQuery} data-id="element-7457" data-mp="n9i0npifaddk" />}
        {activeSection === 'sales-performance' && <SalesPerformanceSection data={mockSalesData} searchQuery={searchQuery} data-id="element-7458" data-mp="27t3mtfpjh75b" />}
        {activeSection === 'customer-analytics' && <CustomerAnalyticsSection data={mockCustomerData} searchQuery={searchQuery} data-id="element-7459" data-mp="23pfh72kgwlmp" />}
        {activeSection === 'market-insights' && <MarketInsightsSection data={mockMarketData} searchQuery={searchQuery} data-id="element-7460" data-mp="2crevhn43lbly" />}
        {activeSection === 'quote-intelligence' && <QuoteIntelligenceSection searchQuery={searchQuery} data-id="element-7461" data-mp="2rfi2mztvmtcc" />}
        {activeSection === 'revenue-intelligence' && <RevenueIntelligenceSection data={mockRevenueData} searchQuery={searchQuery} data-id="element-7462" data-mp="2mh87uqc2dur9" />}
        {activeSection === 'engagement' && <EngagementSection searchQuery={searchQuery} data-id="element-7463" data-mp="30fevzer7ogdq" />}
        {activeSection === 'executive-insights' && <ExecutiveInsightsSection searchQuery={searchQuery} data-id="element-7464" data-mp="2vgbq5s3eq64p" />}
      </div>
    </div>;
}
// ... existing function components ...
function LeadInsightsSection({
  data,
  searchQuery = ''
}) {
  // En una implementación real, aquí filtrarías los datos basados en searchQuery
  return <LeadInsightsOverview data-id="element-7465" data-mp="3187m95m68zqo" />;
}
function SalesPerformanceSection({
  data,
  searchQuery = ''
}) {
  const [selectedManagers, setSelectedManagers] = useState([]);
  const [showManagerFilter, setShowManagerFilter] = useState(false);
  const [selectedDateRange, setSelectedDateRange] = useState('month');
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [dateRange, setDateRange] = useState({
    startDate: new Date(new Date().setDate(new Date().getDate() - 30)).toISOString().split('T')[0],
    endDate: new Date().toISOString().split('T')[0]
  });
  const [isCustomDateRange, setIsCustomDateRange] = useState(false);
  const [filteredSalesManagers, setFilteredSalesManagers] = useState(mockSalesManagers);
  const [filteredRegions, setFilteredRegions] = useState(data.regionPerformance);
  const [filteredProducts, setFilteredProducts] = useState(data.quotesByProduct);
  const [visibleSections, setVisibleSections] = useState({
    activityVolume: true,
    conversionRate: true,
    economicValue: true,
    salesCycle: true,
    internalRanking: true,
    productCharts: true,
    salesTrend: true
  });
  // Filtrar datos basados en la búsqueda
  useEffect(() => {
    if (!searchQuery) {
      // Restaurar todos los datos cuando no hay búsqueda
      setFilteredSalesManagers(mockSalesManagers);
      setFilteredRegions(data.regionPerformance);
      setFilteredProducts(data.quotesByProduct);
      setVisibleSections({
        activityVolume: true,
        conversionRate: true,
        economicValue: true,
        salesCycle: true,
        internalRanking: true,
        productCharts: true,
        salesTrend: true
      });
      return;
    }
    const query = searchQuery.toLowerCase();
    // Filtrar gerentes de ventas
    const managers = mockSalesManagers.filter(manager => manager.name.toLowerCase().includes(query) || manager.region.toLowerCase().includes(query));
    setFilteredSalesManagers(managers);
    // Filtrar regiones
    const regions = data.regionPerformance.filter(region => region.region.toLowerCase().includes(query));
    setFilteredRegions(regions);
    // Filtrar productos
    const products = data.quotesByProduct.filter(product => product.product.toLowerCase().includes(query));
    setFilteredProducts(products);
    // Determinar qué secciones mostrar basado en la búsqueda
    setVisibleSections({
      activityVolume: 'cotizaciones'.includes(query) || 'clientes'.includes(query) || 'interacciones'.includes(query) || 'actividad'.includes(query),
      conversionRate: 'conversión'.includes(query) || 'tasa'.includes(query) || 'porcentaje'.includes(query) || 'quote'.includes(query) || 'orden'.includes(query),
      economicValue: 'valor'.includes(query) || 'económico'.includes(query) || 'ticket'.includes(query) || 'cotizado'.includes(query) || 'cerrado'.includes(query) || 'potencial'.includes(query),
      salesCycle: 'ciclo'.includes(query) || 'tiempo'.includes(query) || 'días'.includes(query) || 'inactividad'.includes(query),
      internalRanking: 'ranking'.includes(query) || 'gerentes'.includes(query) || 'managers'.includes(query) || 'región'.includes(query) || 'regiones'.includes(query),
      productCharts: 'producto'.includes(query) || 'productos'.includes(query) || 'pivot'.includes(query) || 'linear'.includes(query) || 'drip'.includes(query),
      salesTrend: 'tendencia'.includes(query) || 'ventas'.includes(query) || 'mensual'.includes(query) || 'mes'.includes(query)
    });
    // Si la búsqueda no coincide con ninguna sección específica, mostrar todas
    if (!Object.values(visibleSections).some(value => value)) {
      setVisibleSections({
        activityVolume: true,
        conversionRate: true,
        economicValue: true,
        salesCycle: true,
        internalRanking: true,
        productCharts: true,
        salesTrend: true
      });
    }
  }, [searchQuery, data]);
  // Filter data based on selected managers
  const filteredData = useMemo(() => {
    if (selectedManagers.length === 0) {
      return data;
    }
    // Filter sales manager performance
    const filteredManagers = data.salesManagerPerformance.filter(manager => selectedManagers.includes(manager.id));
    // Calculate aggregate metrics based on filtered managers
    const totalQuotes = filteredManagers.reduce((sum, manager) => sum + manager.quotes, 0);
    const wonQuotes = filteredManagers.reduce((sum, manager) => sum + manager.wonQuotes, 0);
    const openQuotes = filteredManagers.reduce((sum, manager) => sum + manager.openQuotes, 0);
    const lostQuotes = filteredManagers.reduce((sum, manager) => sum + manager.lostQuotes, 0);
    const quotedValue = filteredManagers.reduce((sum, manager) => sum + manager.quotedValue, 0);
    const closedValue = filteredManagers.reduce((sum, manager) => sum + manager.closedValue, 0);
    const newCustomers = filteredManagers.reduce((sum, manager) => sum + manager.newCustomers, 0);
    const interactions = filteredManagers.reduce((sum, manager) => sum + manager.interactions, 0);
    // Calculate averages
    const avgConversionRate = totalQuotes > 0 ? wonQuotes / totalQuotes * 100 : 0;
    const avgTicket = totalQuotes > 0 ? quotedValue / totalQuotes : 0;
    const avgCycleTime = filteredManagers.reduce((sum, manager) => sum + manager.avgCycleTime, 0) / filteredManagers.length;
    return {
      ...data,
      totalQuotes,
      activeQuotes: openQuotes,
      expiredQuotes: lostQuotes,
      wonQuotes,
      lostQuotes,
      newCustomers,
      interactions,
      conversionRate: avgConversionRate,
      totalQuotedValue: quotedValue,
      totalClosedValue: closedValue,
      averageQuoteTicket: avgTicket,
      openQuotesValue: quotedValue - closedValue,
      avgQuoteToOrderTime: avgCycleTime
    };
  }, [data, selectedManagers]);
  // ... existing functions ...
  const toggleManager = managerId => {
    setSelectedManagers(prev => prev.includes(managerId) ? prev.filter(id => id !== managerId) : [...prev, managerId]);
  };
  const handleDateRangeChange = e => {
    const value = e.target.value;
    setSelectedDateRange(value);
    setIsCustomDateRange(value === 'custom');
    if (value !== 'custom') {
      // Set predefined date ranges
      const endDate = new Date().toISOString().split('T')[0];
      let startDate;
      switch (value) {
        case 'week':
          startDate = new Date(new Date().setDate(new Date().getDate() - 7)).toISOString().split('T')[0];
          break;
        case 'month':
          startDate = new Date(new Date().setDate(new Date().getDate() - 30)).toISOString().split('T')[0];
          break;
        case 'quarter':
          startDate = new Date(new Date().setDate(new Date().getDate() - 90)).toISOString().split('T')[0];
          break;
        case 'year':
          startDate = new Date(new Date().setFullYear(new Date().getFullYear() - 1)).toISOString().split('T')[0];
          break;
        default:
          startDate = new Date(new Date().setDate(new Date().getDate() - 30)).toISOString().split('T')[0];
      }
      setDateRange({
        startDate,
        endDate
      });
    }
  };
  const handleDateChange = (type, value) => {
    setDateRange(prev => ({
      ...prev,
      [type]: value
    }));
  };
  const clearFilters = () => {
    setSelectedManagers([]);
    setSelectedDateRange('month');
    setIsCustomDateRange(false);
    setDateRange({
      startDate: new Date(new Date().setDate(new Date().getDate() - 30)).toISOString().split('T')[0],
      endDate: new Date().toISOString().split('T')[0]
    });
  };
  // Get date range display text
  const getDateRangeText = () => {
    if (isCustomDateRange) {
      return `${dateRange.startDate} - ${dateRange.endDate}`;
    }
    switch (selectedDateRange) {
      case 'week':
        return 'Últimos 7 días';
      case 'month':
        return 'Últimos 30 días';
      case 'quarter':
        return 'Últimos 90 días';
      case 'year':
        return 'Último año';
      default:
        return 'Últimos 30 días';
    }
  };
  // Renderizar mensaje cuando no hay resultados de búsqueda
  const renderNoResults = () => {
    if (!searchQuery) return null;
    const noVisibleSections = !Object.values(visibleSections).some(value => value);
    if (noVisibleSections) {
      return <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-blue-800/30 text-center" data-id="element-7466" data-mp="e6egtqtdya8g">
          <SearchIcon size={40} className="mx-auto mb-4 text-blue-300 opacity-50" data-id="element-7467" data-mp="3mnhosc02dvn6" />
          <h3 className="text-xl font-medium text-white mb-2" data-id="element-7468" data-mp="3hnws688d9zdm">
            No se encontraron resultados
          </h3>
          <p className="text-blue-300" data-id="element-7469" data-mp="3vo7k7elexk0d">
            No se encontraron paneles que coincidan con "{searchQuery}". Intenta
            con otros términos o{' '}
            <button onClick={() => setSearchQuery('')} className="text-blue-400 hover:text-blue-300 underline" data-id="element-7470" data-mp="1awxb7d2b4hac">
              limpia la búsqueda
            </button>
            .
          </p>
        </div>;
    }
    return null;
  };
  return <div className="space-y-6" data-id="element-7471" data-mp="1edrx28w78s1s">
      {/* Filter Bar - Rediseñado */}
      <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 border border-blue-800/30" data-id="element-7472" data-mp="1ig6f4qs1nns0">
        <div className="flex flex-col gap-4" data-id="element-7473" data-mp="14gx3m4es9hud">
          <div className="flex flex-wrap items-center justify-between gap-4" data-id="element-7474" data-mp="14i84nwgugbhs">
            <div className="flex items-center" data-id="element-7475" data-mp="19gt7m3nhd99x">
              <FilterIcon size={20} className="text-blue-300 mr-2" data-id="element-7476" data-mp="19hl2tdd614zo" />
              <span className="text-white font-semibold text-lg" data-id="element-7477" data-mp="1x5ul45b67am2">
                Filtros de Rendimiento
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-7478" data-mp="1nfj35eunj0w6">
              <button className="flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 rounded-lg text-white transition-colors shadow-md" data-id="element-7479" data-mp="1nezwiuagbyxg">
                <RefreshCwIcon size={18} className="mr-2" data-id="element-7480" data-mp="2g46vtvhqcsjr" />
                Actualizar datos
              </button>
            </div>
          </div>
          {/* Main Filters Row - Rediseñado */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-7481" data-mp="2uqvr1l4y8jkc">
            {/* Date Range Filter */}
            <div data-id="element-7482" data-mp="2prsvcrauzpp1">
              <label className="block text-sm font-medium text-blue-300 mb-1.5" data-id="element-7483" data-mp="2praq5567y14z">
                Período de tiempo
              </label>
              <div className="flex gap-2" data-id="element-7484" data-mp="2kr4wxkkaw6ks">
                <div className="relative flex-1" data-id="element-7485" data-mp="2grea1rxwaalj">
                  <select value={selectedDateRange} onChange={handleDateRangeChange} className="w-full appearance-none bg-blue-900/60 border border-blue-700/40 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all shadow-sm" data-id="element-7486" data-mp="2gqkymdnzqwx2">
                    <option value="week" data-id="element-7487" data-mp="222rk6wan60g2">Últimos 7 días</option>
                    <option value="month" data-id="element-7488" data-mp="1x3na83fw7yoo">Últimos 30 días</option>
                    <option value="quarter" data-id="element-7489" data-mp="1x1ajp1w2kg00">Últimos 90 días</option>
                    <option value="year" data-id="element-7490" data-mp="1t10gty3kq5pd">Último año</option>
                    <option value="custom" data-id="element-7491" data-mp="1o1xamabuxtft">Personalizado</option>
                  </select>
                  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-3 text-blue-300" data-id="element-7492" data-mp="3kodfh8x2aam">
                    <ChevronDownIcon size={18} data-id="element-7493" data-mp="8ipxa4e62dn5" />
                  </div>
                </div>
                <button onClick={() => setShowDatePicker(!showDatePicker)} className="flex items-center px-4 py-2.5 bg-blue-900/60 hover:bg-blue-900/80 rounded-lg text-white border border-blue-700/40 transition-colors shadow-sm" data-id="element-7494" data-mp="ckuokwh56y6m">
                  <CalendarIcon size={18} className="mr-2 text-blue-300" data-id="element-7495" data-mp="3h0vtepqs9ne3" />
                  {getDateRangeText()}
                </button>
              </div>
            </div>
            {/* Sales Managers Filter */}
            <div className="relative" data-id="element-7496" data-mp="3pxwdik6tkzbq">
              <label className="block text-sm font-medium text-blue-300 mb-1.5" data-id="element-7497" data-mp="3ur90yqzrj02w">
                Gerentes de ventas
              </label>
              <button onClick={() => setShowManagerFilter(!showManagerFilter)} className="w-full flex items-center justify-between px-4 py-2.5 bg-blue-900/60 hover:bg-blue-900/80 rounded-lg text-white border border-blue-700/40 transition-colors shadow-sm" data-id="element-7498" data-mp="2xasgb1dyxpai">
                <div className="flex items-center" data-id="element-7499" data-mp="1qo9c1f67abse">
                  <UsersIcon size={18} className="mr-2 text-blue-300" data-id="element-7500" data-mp="1qpu4mz8yfknm" />
                  {selectedManagers.length === 0 ? 'Todos los gerentes' : `${selectedManagers.length} gerente${selectedManagers.length > 1 ? 's' : ''} seleccionado${selectedManagers.length > 1 ? 's' : ''}`}
                </div>
                <ChevronDownIcon size={18} className="text-blue-300" data-id="element-7501" data-mp="2ek3wuz2ikezo" />
              </button>
            </div>
          </div>
          {/* Selected Filters Tags */}
          {(selectedManagers.length > 0 || isCustomDateRange) && <div className="flex flex-wrap gap-2 mt-2 items-center" data-id="element-7502" data-mp="2odknxvb9nfzn">
              {isCustomDateRange && <div className="flex items-center px-2 py-1 bg-blue-800/50 rounded-full text-sm text-white border border-blue-700/40" data-id="element-7503" data-mp="2jerjesdyizbm">
                  <CalendarIcon size={14} className="mr-1.5 text-blue-300" data-id="element-7504" data-mp="2sdv5844idstt" />
                  {dateRange.startDate} - {dateRange.endDate}
                  <button onClick={() => {
              setSelectedDateRange('month');
              setIsCustomDateRange(false);
              setDateRange({
                startDate: new Date(new Date().setDate(new Date().getDate() - 30)).toISOString().split('T')[0],
                endDate: new Date().toISOString().split('T')[0]
              });
            }} className="ml-1.5 text-blue-300 hover:text-white" data-id="element-7505" data-mp="3bzoasnqe1nmb">
                    <XIcon size={14} data-id="element-7506" data-mp="2t6kgd05cj6qn" />
                  </button>
                </div>}
              {selectedManagers.map(managerId => {
            const manager = mockSalesManagers.find(m => m.id === managerId);
            return <div key={manager.id} className="flex items-center px-2 py-1 bg-blue-800/50 rounded-full text-sm text-white border border-blue-700/40" data-id="element-7507" data-mp="2o9kb2rgbm80l">
                    <div className={`w-4 h-4 rounded-full ${manager.color} flex items-center justify-center text-xs text-white mr-1.5`} data-id="element-7508" data-mp="2aab5smtnkybe">
                      {manager.avatar}
                    </div>
                    {manager.name}
                    <button onClick={() => toggleManager(manager.id)} className="ml-1.5 text-blue-300 hover:text-white" data-id="element-7509" data-mp="168ga1wbwrnqj">
                      <XIcon size={14} data-id="element-7510" data-mp="1b6zyq4hvzdml" />
                    </button>
                  </div>;
          })}
              {(selectedManagers.length > 0 || isCustomDateRange) && <button onClick={clearFilters} className="flex items-center px-2.5 py-1 bg-blue-800/30 hover:bg-blue-800/50 rounded-full text-xs text-blue-200 border border-blue-700/30" data-id="element-7511" data-mp="1g4j9uvjafaab">
                  Limpiar todos los filtros
                </button>}
            </div>}
        </div>
      </div>
      {/* Mensaje de no resultados */}
      {renderNoResults()}
      {/* KPI Summary Cards - Volumen de actividad */}
      {visibleSections.activityVolume && <div data-id="element-7512" data-mp="23wzthaiobabq">
          <h3 className="text-lg font-medium text-white mb-3 flex items-center" data-id="element-7513" data-mp="23x9o5beny5nr">
            <BarChart3Icon size={18} className="mr-2 text-blue-400" data-id="element-7514" data-mp="28ui5j9rzm5ny" />
            Volumen de actividad
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-7515" data-mp="3te3qiwndate4">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 border border-blue-800/30" data-id="element-7516" data-mp="3odzjdx8cnb0k">
              <div className="flex items-center justify-between mb-2" data-id="element-7517" data-mp="3jecwsx6msif3">
                <h3 className="text-blue-300 text-sm font-medium" data-id="element-7518" data-mp="3eg320notjju0">
                  Cotizaciones
                </h3>
                <FileTextIcon className="text-blue-400" size={20} data-id="element-7519" data-mp="fyz4y62180vb" />
              </div>
              <div className="text-3xl font-bold text-white" data-id="element-7520" data-mp="azmihmf2ovt9">
                {filteredData.totalQuotes.toLocaleString()}
              </div>
              <div className="flex items-center mt-2 text-sm" data-id="element-7521" data-mp="67bdw69e0lud">
                <div className="flex items-center text-blue-300" data-id="element-7522" data-mp="1a2y2cbpotwa">
                  <span data-id="element-7523" data-mp="17p2m2d4dfo7">
                    {filteredData.activeQuotes} abiertas,{' '}
                    {filteredData.wonQuotes} ganadas, {filteredData.lostQuotes}{' '}
                    perdidas
                  </span>
                </div>
              </div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 border border-blue-800/30" data-id="element-7524" data-mp="2o6ue31i3lofs">
              <div className="flex items-center justify-between mb-2" data-id="element-7525" data-mp="2t4cjihwwplj1">
                <h3 className="text-blue-300 text-sm font-medium" data-id="element-7526" data-mp="2efg9wgf7c0gb">
                  Clientes Nuevos
                </h3>
                <UserPlusIcon className="text-green-400" size={20} data-id="element-7527" data-mp="2jdhux6w6u9uf" />
              </div>
              <div className="text-3xl font-bold text-white" data-id="element-7528" data-mp="25e00oc04i4do">
                {filteredData.newCustomers}
              </div>
              <div className="flex items-center mt-2 text-sm" data-id="element-7529" data-mp="29etnf21txd4z">
                <div className="flex items-center text-green-400" data-id="element-7530" data-mp="1viosydn4txff">
                  <ArrowUpIcon size={14} className="mr-1" data-id="element-7531" data-mp="20fyhzs6m072q" />
                  <span data-id="element-7532" data-mp="20ikpxsxewolh">+12% vs mes anterior</span>
                </div>
              </div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 border border-blue-800/30" data-id="element-7533" data-mp="3ptli5lmg6whg">
              <div className="flex items-center justify-between mb-2" data-id="element-7534" data-mp="3us543m11k89t">
                <h3 className="text-blue-300 text-sm font-medium" data-id="element-7535" data-mp="1j7feyenm2hng">
                  Interacciones
                </h3>
                <MessageSquareIcon className="text-amber-400" size={20} data-id="element-7536" data-mp="1e686eddn9efq" />
              </div>
              <div className="text-3xl font-bold text-white" data-id="element-7537" data-mp="1sz1zx2pr3v3e">
                {filteredData.interactions.toLocaleString()}
              </div>
              <div className="flex items-center mt-2 text-sm" data-id="element-7538" data-mp="21x439owyiztu">
                <div className="flex items-center text-blue-300" data-id="element-7539" data-mp="21zgnk8q6tma2">
                  <span data-id="element-7540" data-mp="1wy0ze7spqzng">Seguimientos, notas y recordatorios</span>
                </div>
              </div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 border border-blue-800/30" data-id="element-7541" data-mp="2btqo4dpa9qvv">
              <div className="flex items-center justify-between mb-2" data-id="element-7542" data-mp="26unmz4cfc4t6">
                <h3 className="text-blue-300 text-sm font-medium" data-id="element-7543" data-mp="hibz5z43jvh6">
                  Actividad Promedio
                </h3>
                <ActivityIcon className="text-purple-400" size={20} data-id="element-7544" data-mp="ckscqbx8wce5" />
              </div>
              <div className="text-3xl font-bold text-white" data-id="element-7545" data-mp="2zqwtvmlewx22">
                {(filteredData.interactions / filteredData.totalQuotes).toFixed(1)}
              </div>
              <div className="flex items-center mt-2 text-sm" data-id="element-7546" data-mp="39qdxlyh3t0ve">
                <div className="flex items-center text-blue-300" data-id="element-7547" data-mp="3dqxv535la6i2">
                  <span data-id="element-7548" data-mp="3dq4sad9r4157">Interacciones por cotización</span>
                </div>
              </div>
            </div>
          </div>
        </div>}
      {/* Tasa de conversión */}
      {visibleSections.conversionRate && <div data-id="element-7549" data-mp="2lxnijgdwm1gw">
          <h3 className="text-lg font-medium text-white mb-3 flex items-center" data-id="element-7550" data-mp="2q1da8epvkz65">
            <PercentIcon size={18} className="mr-2 text-blue-400" data-id="element-7551" data-mp="2pz8xd7a00ptq" />
            Tasa de conversión
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-7552" data-mp="1ya5qdjqq91de">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 border border-blue-800/30" data-id="element-7553" data-mp="1y9xbxneyho03">
              <div className="flex items-center justify-between mb-2" data-id="element-7554" data-mp="229y2g6fbxpni">
                <h3 className="text-blue-300 text-sm font-medium" data-id="element-7555" data-mp="1ur6y9zbgrfii">
                  Quote → Orden
                </h3>
                <TrendingUpIcon className="text-green-400" size={20} data-id="element-7556" data-mp="1ptoknvmi4c46" />
              </div>
              <div className="text-3xl font-bold text-white" data-id="element-7557" data-mp="1lq8ot1i9afsj">
                {filteredData.conversionRate.toFixed(1)}%
              </div>
              <div className="flex items-center mt-2 text-sm" data-id="element-7558" data-mp="1guticumkvm65">
                <div className="flex items-center text-green-400" data-id="element-7559" data-mp="1buyoqjbf4ihe">
                  <ArrowUpIcon size={14} className="mr-1" data-id="element-7560" data-mp="172fadk4wpjbj" />
                  <span data-id="element-7561" data-mp="170uglwqf24eq">+2.3% vs trimestre anterior</span>
                </div>
              </div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 border border-blue-800/30" data-id="element-7562" data-mp="y1z7abs2se77">
              <div className="flex items-center justify-between mb-2" data-id="element-7563" data-mp="t2moq388ltaf">
                <h3 className="text-blue-300 text-sm font-medium" data-id="element-7564" data-mp="t4z20331vfh5">
                  Conversión por Etapa
                </h3>
                <LayersIcon className="text-blue-400" size={20} data-id="element-7565" data-mp="eggy6slnqu5x" />
              </div>
              <div className="space-y-2 mt-2" data-id="element-7566" data-mp="eijufudeljj3">
                <div data-id="element-7567" data-mp="jgblkm6851m8">
                  <div className="flex justify-between items-center" data-id="element-7568" data-mp="jglg8n27rwy9">
                    <span className="text-xs text-blue-200" data-id="element-7569" data-mp="4j2ultku1zv1">
                      Diseño → Quote
                    </span>
                    <span className="text-xs text-white" data-id="element-7570" data-mp="9hmdfl44qvj6">
                      {filteredData.designToQuoteConversion}%
                    </span>
                  </div>
                  <div className="w-full bg-blue-900/50 rounded-full h-1.5 mt-1" data-id="element-7571" data-mp="124qe5dw6wnp5">
                    <div className="h-1.5 rounded-full bg-blue-500" style={{
                  width: `${filteredData.designToQuoteConversion}%`
                }} data-id="element-7572" data-mp="nhf5bjre7hsq"></div>
                  </div>
                </div>
                <div data-id="element-7573" data-mp="1g5b0gk1bd1ne">
                  <div className="flex justify-between items-center" data-id="element-7574" data-mp="1g3zvigw4tnup">
                    <span className="text-xs text-blue-200" data-id="element-7575" data-mp="1kwj6d63fq4vt">Quote → Orden</span>
                    <span className="text-xs text-white" data-id="element-7576" data-mp="35mevy1qd0cno">
                      {filteredData.quoteToOrderConversion}%
                    </span>
                  </div>
                  <div className="w-full bg-blue-900/50 rounded-full h-1.5 mt-1" data-id="element-7577" data-mp="30lhdrp5cnim6">
                    <div className="h-1.5 rounded-full bg-green-500" style={{
                  width: `${filteredData.quoteToOrderConversion}%`
                }} data-id="element-7578" data-mp="3fbon9fddpraq"></div>
                  </div>
                </div>
                <div data-id="element-7579" data-mp="2mpww0x1cx6gc">
                  <div className="flex justify-between items-center" data-id="element-7580" data-mp="2hopq73iryhcb">
                    <span className="text-xs text-blue-200" data-id="element-7581" data-mp="2hqu145f3cgm3">
                      Diseño → Orden
                    </span>
                    <span className="text-xs text-white" data-id="element-7582" data-mp="2rmx2h924cb7z">
                      {filteredData.designToOrderConversion}%
                    </span>
                  </div>
                  <div className="w-full bg-blue-900/50 rounded-full h-1.5 mt-1" data-id="element-7583" data-mp="awgjq7jxgze0">
                    <div className="h-1.5 rounded-full bg-purple-500" style={{
                  width: `${filteredData.designToOrderConversion}%`
                }} data-id="element-7584" data-mp="6w4x4p808ozw"></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 border border-blue-800/30" data-id="element-7585" data-mp="2aduqv5fd19rc">
              <div className="flex items-center justify-between mb-2" data-id="element-7586" data-mp="2f41h19pit2bp">
                <h3 className="text-blue-300 text-sm font-medium" data-id="element-7587" data-mp="2f64eget05xqg">
                  Conversión por Tipo de Cliente
                </h3>
                <UsersIcon className="text-amber-400" size={20} data-id="element-7588" data-mp="2o4gawxgjvpqt" />
              </div>
              <div className="space-y-2 mt-2" data-id="element-7589" data-mp="2t4c7wcqtygwv">
                <div data-id="element-7590" data-mp="2t4lz23nm2u45">
                  <div className="flex justify-between items-center" data-id="element-7591" data-mp="2t1zp5xd902ir">
                    <span className="text-xs text-blue-200" data-id="element-7592" data-mp="2y1uf9yp78o2r">Nuevos</span>
                    <span className="text-xs text-white" data-id="element-7593" data-mp="yqte9dzx7igu">
                      {filteredData.newCustomerConversion}%
                    </span>
                  </div>
                  <div className="w-full bg-blue-900/50 rounded-full h-1.5 mt-1" data-id="element-7594" data-mp="3gze5gri121wz">
                    <div className="h-1.5 rounded-full bg-blue-500" style={{
                  width: `${filteredData.newCustomerConversion}%`
                }} data-id="element-7595" data-mp="3h1il26pagpd3"></div>
                  </div>
                </div>
                <div data-id="element-7596" data-mp="384q59frb7af1">
                  <div className="flex justify-between items-center" data-id="element-7597" data-mp="338j5k4piav5j">
                    <span className="text-xs text-blue-200" data-id="element-7598" data-mp="3366ff49lhehe">Recurrentes</span>
                    <span className="text-xs text-white" data-id="element-7599" data-mp="3s2ywjn7oa9q">
                      {filteredData.recurringCustomerConversion}%
                    </span>
                  </div>
                  <div className="w-full bg-blue-900/50 rounded-full h-1.5 mt-1" data-id="element-7600" data-mp="3qwirmrbvhxds">
                    <div className="h-1.5 rounded-full bg-green-500" style={{
                  width: `${filteredData.recurringCustomerConversion}%`
                }} data-id="element-7601" data-mp="3lzabewaac3f6"></div>
                  </div>
                </div>
                <div data-id="element-7602" data-mp="2aikc7x4a4bv2">
                  <div className="flex justify-between items-center" data-id="element-7603" data-mp="2ai0t4d2w7hfg">
                    <span className="text-xs text-blue-200" data-id="element-7604" data-mp="3ctwct4e27r2e">Estratégicos</span>
                    <span className="text-xs text-white" data-id="element-7605" data-mp="37vbc73uwb5df">
                      {filteredData.strategicCustomerConversion}%
                    </span>
                  </div>
                  <div className="w-full bg-blue-900/50 rounded-full h-1.5 mt-1" data-id="element-7606" data-mp="2xxovqcxy75rc">
                    <div className="h-1.5 rounded-full bg-amber-500" style={{
                  width: `${filteredData.strategicCustomerConversion}%`
                }} data-id="element-7607" data-mp="2xzro33mkpaz8"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>}
      {/* Valor económico */}
      {visibleSections.economicValue && <div data-id="element-7608" data-mp="2f7ysr2k17doc">
          <h3 className="text-lg font-medium text-white mb-3 flex items-center" data-id="element-7609" data-mp="2f8iaai5rs01u">
            <DollarSignIcon size={18} className="mr-2 text-blue-400" data-id="element-7610" data-mp="2a8cfwu847zg2" />
            Valor económico
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-7611" data-mp="267k7g372hyku">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 border border-blue-800/30" data-id="element-7612" data-mp="lp87o4xfyojw">
              <div className="flex items-center justify-between mb-2" data-id="element-7613" data-mp="ppacuo2dy03x">
                <h3 className="text-blue-300 text-sm font-medium" data-id="element-7614" data-mp="up508hmyc7k8">
                  Valor Cotizado vs Cerrado
                </h3>
                <TrendingUpIcon className="text-green-400" size={20} data-id="element-7615" data-mp="zohlixy6d6kp" />
              </div>
              <div className="flex justify-between items-center" data-id="element-7616" data-mp="218w4rv1zddf">
                <div data-id="element-7617" data-mp="1ymsh3ba9i0h">
                  <div className="text-sm text-blue-200" data-id="element-7618" data-mp="6z0ykftbqhvv">Valor Cotizado</div>
                  <div className="text-2xl font-bold text-white" data-id="element-7619" data-mp="bynckrgz825q">
                    ${(filteredData.totalQuotedValue / 1000000).toFixed(1)}M
                  </div>
                </div>
                <div className="text-2xl text-blue-300 px-2" data-id="element-7620" data-mp="grgdt5d8ksd2">vs</div>
                <div className="text-right" data-id="element-7621" data-mp="3fekl6vzhp21y">
                  <div className="text-sm text-blue-200" data-id="element-7622" data-mp="3kegsp57ebbm9">Valor Cerrado</div>
                  <div className="text-2xl font-bold text-green-400" data-id="element-7623" data-mp="3kcdtpvo9m85e">
                    ${(filteredData.totalClosedValue / 1000000).toFixed(1)}M
                  </div>
                </div>
              </div>
              <div className="w-full bg-blue-900/50 rounded-full h-2 mt-3" data-id="element-7624" data-mp="38acs43v881ce">
                <div className="h-2 rounded-full bg-green-500" style={{
              width: `${filteredData.totalClosedValue / filteredData.totalQuotedValue * 100}%`
            }} data-id="element-7625" data-mp="3m2sowmxjb34v"></div>
              </div>
              <div className="flex justify-between mt-1" data-id="element-7626" data-mp="2tgzim3d156dc">
                <span className="text-xs text-blue-300" data-id="element-7627" data-mp="2peczcqufctrr">
                  {(filteredData.totalClosedValue / filteredData.totalQuotedValue * 100).toFixed(1)}
                  % del valor cotizado
                </span>
              </div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 border border-blue-800/30" data-id="element-7628" data-mp="2ygce1chyvlrj">
              <div className="flex items-center justify-between mb-2" data-id="element-7629" data-mp="dnr55m8jdvfo">
                <h3 className="text-blue-300 text-sm font-medium" data-id="element-7630" data-mp="dnirvt8i4o3y">
                  Ticket Promedio
                </h3>
                <HashIcon className="text-amber-400" size={20} data-id="element-7631" data-mp="1vnqg644titrl" />
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-7632" data-mp="20idvbcdxmbti">
                <div data-id="element-7633" data-mp="1mlh439twisc3">
                  <div className="text-sm text-blue-200" data-id="element-7634" data-mp="1mma4lt29olls">Por Cotización</div>
                  <div className="text-2xl font-bold text-white" data-id="element-7635" data-mp="1rktsw04c29hb">
                    ${(filteredData.averageQuoteTicket / 1000).toFixed(1)}K
                  </div>
                  <div className="text-xs text-blue-300 mt-1" data-id="element-7636" data-mp="2jayj4ferxqqg">
                    Promedio global
                  </div>
                </div>
                <div data-id="element-7637" data-mp="25is4wyv6lttn">
                  <div className="text-sm text-blue-200" data-id="element-7638" data-mp="25jbensaohbwl">Por Orden</div>
                  <div className="text-2xl font-bold text-green-400" data-id="element-7639" data-mp="2ahmow44vxofc">
                    ${(filteredData.averageOrderTicket / 1000).toFixed(1)}K
                  </div>
                  <div className="text-xs text-green-400 mt-1" data-id="element-7640" data-mp="32zh4elwnsjzv">
                    <ArrowUpIcon size={10} className="inline mr-1" data-id="element-7641" data-mp="331204eupm8zb" />
                    +5.2% vs año anterior
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 border border-blue-800/30" data-id="element-7642" data-mp="19cqhq475zvjl">
              <div className="flex items-center justify-between mb-2" data-id="element-7643" data-mp="15ekbcxa8nhz7">
                <h3 className="text-blue-300 text-sm font-medium" data-id="element-7644" data-mp="10eohvrz638xw">
                  Valor Potencial
                </h3>
                <TargetIcon className="text-purple-400" size={20} data-id="element-7645" data-mp="1x2ufhuxo912o" />
              </div>
              <div className="text-3xl font-bold text-white" data-id="element-7646" data-mp="1t2kbgntfwkqg">
                ${(filteredData.openQuotesValue / 1000000).toFixed(1)}M
              </div>
              <div className="text-sm text-blue-200 mt-2" data-id="element-7647" data-mp="1jchd083juekq">
                Valor de cotizaciones abiertas
              </div>
              <div className="flex items-center mt-2" data-id="element-7648" data-mp="2gsodwruw6efv">
                <div className="w-full bg-blue-900/50 rounded-full h-2" data-id="element-7649" data-mp="2c0wmyg7tq6p7">
                  <div className="h-2 rounded-full bg-purple-500" style={{
                width: `${filteredData.activeQuotes / filteredData.totalQuotes * 100}%`
              }} data-id="element-7650" data-mp="2bzlgu9qwomux"></div>
                </div>
              </div>
              <div className="text-xs text-blue-300 mt-1" data-id="element-7651" data-mp="2ta8pc9ngbjcl">
                {filteredData.activeQuotes} cotizaciones abiertas (
                {(filteredData.activeQuotes / filteredData.totalQuotes * 100).toFixed(1)}
                %)
              </div>
            </div>
          </div>
        </div>}
      {/* Tiempo de ciclo de ventas */}
      {visibleSections.salesCycle && <div data-id="element-7652" data-mp="3785p1ex7c5vh">
          <h3 className="text-lg font-medium text-white mb-3 flex items-center" data-id="element-7653" data-mp="377ngpjx9m177">
            <ClockIcon size={18} className="mr-2 text-blue-400" data-id="element-7654" data-mp="3c1i7t8f79igb" />
            Tiempo de ciclo de ventas
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-7655" data-mp="3h1mey7u7x0tv">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 border border-blue-800/30" data-id="element-7656" data-mp="3l2zmqngvfe3f">
              <div className="flex items-center justify-between mb-2" data-id="element-7657" data-mp="3q113h1qtr1bq">
                <h3 className="text-blue-300 text-sm font-medium" data-id="element-7658" data-mp="1pxgo59uspizk">
                  Tiempo por Etapa
                </h3>
                <LayersIcon className="text-blue-400" size={20} data-id="element-7659" data-mp="1ly7xidv1y188" />
              </div>
              <div className="space-y-4 mt-2" data-id="element-7660" data-mp="1zp37xul78qdx">
                <div data-id="element-7661" data-mp="1zpwbynsrx1sd">
                  <div className="flex justify-between items-center mb-1" data-id="element-7662" data-mp="1uwtdc195325b">
                    <span className="text-sm text-blue-200" data-id="element-7663" data-mp="1uvicoaazqaif">
                      Diseño → Quote
                    </span>
                    <span className="text-sm text-white" data-id="element-7664" data-mp="24no1jb5y4bte">
                      {filteredData.avgDesignToQuoteTime} días
                    </span>
                  </div>
                  <div className="w-full bg-blue-900/50 rounded-full h-2" data-id="element-7665" data-mp="2ikjma0vk7rpa">
                    <div className="h-2 rounded-full bg-blue-500" style={{
                  width: `${filteredData.avgDesignToQuoteTime / 20 * 100}%`
                }} data-id="element-7666" data-mp="2dom55sch2hbg"></div>
                  </div>
                </div>
                <div data-id="element-7667" data-mp="jc6559a9rzf1">
                  <div className="flex justify-between items-center mb-1" data-id="element-7668" data-mp="2uxewmp0va5ub">
                    <span className="text-sm text-blue-200" data-id="element-7669" data-mp="2uzholelky91o">Quote → Orden</span>
                    <span className="text-sm text-white" data-id="element-7670" data-mp="2zvgfp9yam55s">
                      {filteredData.avgQuoteToOrderTime} días
                    </span>
                  </div>
                  <div className="w-full bg-blue-900/50 rounded-full h-2" data-id="element-7671" data-mp="2q5dh8u8ejz02">
                    <div className="h-2 rounded-full bg-green-500" style={{
                  width: `${filteredData.avgQuoteToOrderTime / 20 * 100}%`
                }} data-id="element-7672" data-mp="2c64a0k26cf88"></div>
                  </div>
                </div>
                <div data-id="element-7673" data-mp="2370qjez3hxt7">
                  <div className="flex justify-between items-center mb-1" data-id="element-7674" data-mp="237k1ucu8pny9">
                    <span className="text-sm text-blue-200" data-id="element-7675" data-mp="278lz4o4ljpxl">Ciclo Total</span>
                    <span className="text-sm text-white" data-id="element-7676" data-mp="1e2vdchuit53">
                      {(filteredData.avgDesignToQuoteTime + filteredData.avgQuoteToOrderTime).toFixed(1)}{' '}
                      días
                    </span>
                  </div>
                  <div className="w-full bg-blue-900/50 rounded-full h-2" data-id="element-7677" data-mp="2pbgq6ygex2ho">
                    <div className="h-2 rounded-full bg-purple-500" style={{
                  width: `${(filteredData.avgDesignToQuoteTime + filteredData.avgQuoteToOrderTime) / 20 * 100}%`
                }} data-id="element-7678" data-mp="2ke6wh6lzq4o1"></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 border border-blue-800/30" data-id="element-7679" data-mp="26ms7mj5ej992">
              <div className="flex items-center justify-between mb-2" data-id="element-7680" data-mp="21lmdcgw3fdxf">
                <h3 className="text-blue-300 text-sm font-medium" data-id="element-7681" data-mp="1wn1dwjoo0ya1">
                  Tiempos de Inactividad
                </h3>
                <AlertTriangleIcon className="text-amber-400" size={20} data-id="element-7682" data-mp="1rprsdf4ed6rh" />
              </div>
              <div className="text-3xl font-bold text-white" data-id="element-7683" data-mp="3r0j6il3xglbx">
                {filteredData.avgInactivityTime} días
              </div>
              <div className="text-sm text-blue-200 mt-2" data-id="element-7684" data-mp="3m0emwm7q3ahh">
                Promedio de tiempo sin respuesta del cliente
              </div>
              <div className="mt-4" data-id="element-7685" data-mp="2f7b3j7mvacf">
                <div className="flex justify-between items-center mb-1" data-id="element-7686" data-mp="2e5zndmpglu6">
                  <span className="text-xs text-blue-200" data-id="element-7687" data-mp="765uwsrtyqkf">
                    Cotizaciones inactivas
                  </span>
                  <span className="text-xs text-white" data-id="element-7688" data-mp="c50omprc5zjb">42 cotizaciones</span>
                </div>
                <div className="flex items-center space-x-1" data-id="element-7689" data-mp="3bm8cggmheflv">
                  <div className="h-2 bg-red-500 rounded-l w-1/4" data-id="element-7690" data-mp="3flpjvflgxmto"></div>
                  <div className="h-2 bg-amber-500 w-1/4" data-id="element-7691" data-mp="3klbwpnxdx11y"></div>
                  <div className="h-2 bg-yellow-500 w-1/4" data-id="element-7692" data-mp="3kjr3q2qpxq67"></div>
                  <div className="h-2 bg-green-500 rounded-r w-1/4" data-id="element-7693" data-mp="3pkov95xmbwkd"></div>
                </div>
                <div className="flex justify-between text-xs text-blue-300 mt-1" data-id="element-7694" data-mp="zvmk7hk5lrcf">
                  <span data-id="element-7695" data-mp="14txt9q2mjxtl">+15 días</span>
                  <span data-id="element-7696" data-mp="14swhfjdsb7at">10-15 días</span>
                  <span data-id="element-7697" data-mp="14w0sn0po33az">5-10 días</span>
                  <span data-id="element-7698" data-mp="369uu044j21px">&lt;5 días</span>
                </div>
              </div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 border border-blue-800/30" data-id="element-7699" data-mp="3aby5gsr756b7">
              <div className="flex items-center justify-between mb-2" data-id="element-7700" data-mp="2wl33m0f47ph4">
                <h3 className="text-blue-300 text-sm font-medium" data-id="element-7701" data-mp="31jeca7tobtxr">
                  Comparativa por Región
                </h3>
                <GlobeIcon className="text-purple-400" size={20} data-id="element-7702" data-mp="2mlubze7q2mxx" />
              </div>
              <div className="space-y-3 mt-2" data-id="element-7703" data-mp="2rlq8kse3bc3g">
                {filteredRegions.slice(0, 3).map(region => <div key={region.region} data-id="element-7704" data-mp="2dlp7bbtwy2ng">
                    <div className="flex justify-between items-center mb-1" data-id="element-7705" data-mp="2dn09x8bmh4cz">
                      <span className="text-sm text-blue-200" data-id="element-7706" data-mp="2iljylghlou91">
                        {region.region}
                      </span>
                      <span className="text-sm text-white" data-id="element-7707" data-mp="buu6u6orhfae">
                        {region.avgCycleTime} días
                      </span>
                    </div>
                    <div className="w-full bg-blue-900/50 rounded-full h-2" data-id="element-7708" data-mp="qy5g0vxu43ck">
                      <div className={`h-2 rounded-full ${region.region === 'Latinoamérica' ? 'bg-green-500' : region.region === 'Europa' ? 'bg-blue-500' : region.region === 'Norteamérica' ? 'bg-purple-500' : region.region === 'Asia Pacífico' ? 'bg-amber-500' : 'bg-red-500'}`} style={{
                  width: `${region.avgCycleTime / 20 * 100}%`
                }} data-id="element-7709" data-mp="lyj36nlx4p4a"></div>
                    </div>
                  </div>)}
                {filteredRegions.length > 3 && <button className="text-xs text-blue-400 hover:text-blue-300 mt-2" data-id="element-7710" data-mp="14o8xzapolaw7">
                    Ver todas las regiones
                  </button>}
              </div>
            </div>
          </div>
        </div>}
      {/* Ranking interno */}
      {visibleSections.internalRanking && <div data-id="element-7711" data-mp="3kgeo1tw291ip">
          <h3 className="text-lg font-medium text-white mb-3 flex items-center" data-id="element-7712" data-mp="3kfwqmtxnwh97">
            <BarChart3Icon size={18} className="mr-2 text-blue-400" data-id="element-7713" data-mp="3gfcsbn1cr7lh" />
            Ranking interno
          </h3>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-7714" data-mp="1jf8blnrysbuk">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl border border-blue-800/30 overflow-hidden" data-id="element-7715" data-mp="1obp2uqugn6bv">
              <div className="p-4 border-b border-blue-800/30 flex justify-between items-center" data-id="element-7716" data-mp="1tas6c6usl4hq">
                <h3 className="text-base font-medium text-white flex items-center" data-id="element-7717" data-mp="1ybfw6p7abfad">
                  <UsersIcon size={16} className="mr-2 text-blue-400" data-id="element-7718" data-mp="22d1c6jf489os" />
                  Top Sales Managers
                </h3>
                <div className="flex space-x-2" data-id="element-7719" data-mp="279rr33f6oz8m">
                  <button className="text-xs bg-blue-600 text-white px-2 py-1 rounded-md" data-id="element-7720" data-mp="2c1jb0v3u46ps">
                    Por Valor
                  </button>
                  <button className="text-xs bg-blue-800/50 hover:bg-blue-800/70 text-blue-200 px-2 py-1 rounded-md" data-id="element-7721" data-mp="2h0me4a0982v4">
                    Por Volumen
                  </button>
                </div>
              </div>
              <div className="overflow-x-auto" data-id="element-7722" data-mp="2pzrhbtmrgkdm">
                <table className="w-full" data-id="element-7723" data-mp="eequxjm1oeyz">
                  <thead data-id="element-7724" data-mp="ece4ei280wab">
                    <tr className="border-b border-blue-800/30 text-left" data-id="element-7725" data-mp="ad5c7hmtx6gv">
                      <th className="px-4 py-3 text-xs font-medium text-blue-300 uppercase tracking-wider" data-id="element-7726" data-mp="aezzv3phjcon">
                        Sales Manager
                      </th>
                      <th className="px-4 py-3 text-xs font-medium text-blue-300 uppercase tracking-wider" data-id="element-7727" data-mp="gaf9367fe4p">
                        Región
                      </th>
                      <th className="px-4 py-3 text-xs font-medium text-blue-300 uppercase tracking-wider text-right" data-id="element-7728" data-mp="t2v8k968q0aw">
                        Cotizaciones
                      </th>
                      <th className="px-4 py-3 text-xs font-medium text-blue-300 uppercase tracking-wider text-right" data-id="element-7729" data-mp="jdv44a8yycpb">
                        Valor Cerrado
                      </th>
                      <th className="px-4 py-3 text-xs font-medium text-blue-300 uppercase tracking-wider text-right" data-id="element-7730" data-mp="1gusjzz5s2qbh">
                        Conversión
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-blue-800/30" data-id="element-7731" data-mp="10mcmby03aft7">
                    {filteredData.salesManagerPerformance.sort((a, b) => b.closedValue - a.closedValue).slice(0, 5).map((manager, index) => <tr key={manager.id} className={`hover:bg-blue-800/20 transition-colors ${selectedManagers.includes(manager.id) ? 'bg-blue-800/30' : ''}`} data-id="element-7732" data-mp="rkwhs6vyh7ww" data-mpi={index}>
                          <td className="px-4 py-3 text-sm text-white font-medium" data-id="element-7733" data-mp="1fctv62f20804">
                            <div className="flex items-center" data-id="element-7734" data-mp="1k9ag6nqyi68z">
                              <div className={`w-6 h-6 rounded-full ${index === 0 ? 'bg-amber-500' : index === 1 ? 'bg-blue-500' : index === 2 ? 'bg-green-500' : index === 3 ? 'bg-purple-500' : 'bg-red-500'} flex items-center justify-center text-xs text-white mr-2`} data-id="element-7735" data-mp="15lpft1lgul4r">
                                {manager.name.split(' ').map(n => n[0]).join('')}
                              </div>
                              {manager.name}
                            </div>
                          </td>
                          <td className="px-4 py-3 text-sm text-blue-200" data-id="element-7736" data-mp="3is5ijdma3u4p">
                            {manager.region}
                          </td>
                          <td className="px-4 py-3 text-sm text-white text-right" data-id="element-7737" data-mp="fqy6grnzdle">
                            {manager.quotes}
                          </td>
                          <td className="px-4 py-3 text-sm text-green-400 text-right" data-id="element-7738" data-mp="34sw4okljpc3w">
                            ${(manager.closedValue / 1000).toFixed(0)}K
                          </td>
                          <td className="px-4 py-3 text-right" data-id="element-7739" data-mp="3dssyt1qpf36c">
                            <div className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-900/30 text-blue-200 border border-blue-700/30" data-id="element-7740" data-mp="3dq6jgfxknjdk">
                              {manager.conversionRate.toFixed(1)}%
                            </div>
                          </td>
                        </tr>)}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl border border-blue-800/30 overflow-hidden" data-id="element-7741" data-mp="3mua2e4x1t6ck">
              <div className="p-4 border-b border-blue-800/30 flex justify-between items-center" data-id="element-7742" data-mp="3qvdgalvjcsb5">
                <h3 className="text-base font-medium text-white flex items-center" data-id="element-7743" data-mp="3vvhxyf86jt2y">
                  <GlobeIcon size={16} className="mr-2 text-blue-400" data-id="element-7744" data-mp="2z4pct36e3aub" />
                  Rendimiento por Región
                </h3>
                <div className="flex space-x-2" data-id="element-7745" data-mp="337ccfq9ay022">
                  <button className="text-xs bg-blue-600 text-white px-2 py-1 rounded-md" data-id="element-7746" data-mp="333y6y95cdaqe">
                    Por Conversión
                  </button>
                  <button className="text-xs bg-blue-800/50 hover:bg-blue-800/70 text-blue-200 px-2 py-1 rounded-md" data-id="element-7747" data-mp="3cx5k4g6bpv11">
                    Por Valor
                  </button>
                </div>
              </div>
              <div className="overflow-x-auto" data-id="element-7748" data-mp="2ke8gtzcixd4t">
                <table className="w-full" data-id="element-7749" data-mp="2cw1to0qeaspc">
                  <thead data-id="element-7750" data-mp="2cuz2rst2oq9f">
                    <tr className="border-b border-blue-800/30 text-left" data-id="element-7751" data-mp="2cu7ihe4xeeyg">
                      <th className="px-4 py-3 text-xs font-medium text-blue-300 uppercase tracking-wider" data-id="element-7752" data-mp="27xqjtq03oi74">
                        Región
                      </th>
                      <th className="px-4 py-3 text-xs font-medium text-blue-300 uppercase tracking-wider text-right" data-id="element-7753" data-mp="1yxajuqikft70">
                        Cotizaciones
                      </th>
                      <th className="px-4 py-3 text-xs font-medium text-blue-300 uppercase tracking-wider text-right" data-id="element-7754" data-mp="1p6zeczj8hby0">
                        Ganadas
                      </th>
                      <th className="px-4 py-3 text-xs font-medium text-blue-300 uppercase tracking-wider text-right" data-id="element-7755" data-mp="1k5a1decgao7a">
                        Conversión
                      </th>
                      <th className="px-4 py-3 text-xs font-medium text-blue-300 uppercase tracking-wider text-right" data-id="element-7756" data-mp="1b652u80w2uv4">
                        Ciclo
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-blue-800/30" data-id="element-7757" data-mp="2z3mfd4huktz3">
                    {filteredRegions.sort((a, b) => b.conversionRate - a.conversionRate).map(region => <tr key={region.region} className="hover:bg-blue-800/20 transition-colors" data-id="element-7758" data-mp="2l339a2wxzxzk">
                          <td className="px-4 py-3 text-sm text-white font-medium" data-id="element-7759" data-mp="2p45auqec0m4p">
                            {region.region}
                          </td>
                          <td className="px-4 py-3 text-sm text-white text-right" data-id="element-7760" data-mp="2g4ib09193odr">
                            {region.quotes}
                          </td>
                          <td className="px-4 py-3 text-sm text-green-400 text-right" data-id="element-7761" data-mp="21hp2bmm8lguj">
                            {region.wonQuotes}
                          </td>
                          <td className="px-4 py-3 text-right" data-id="element-7762" data-mp="1sg8sbfzc3gqu">
                            <div className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-900/30 text-blue-200 border border-blue-700/30" data-id="element-7763" data-mp="1xeakqringsez">
                              {region.conversionRate.toFixed(1)}%
                            </div>
                          </td>
                          <td className="px-4 py-3 text-sm text-blue-200 text-right" data-id="element-7764" data-mp="1mt6yic4ugvjb">
                            {region.avgCycleTime} días
                          </td>
                        </tr>)}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>}
      {/* Charts and Tables - Original content */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-7765" data-mp="1rrqja97pc1a3">
        {/* Cotizaciones por Producto */}
        {visibleSections.productCharts && <div className="bg-white/10 backdrop-blur-sm rounded-xl border border-blue-800/30 p-5" data-id="element-7766" data-mp="21i313to4tgcj">
            <h3 className="text-lg font-medium text-white mb-4 flex items-center" data-id="element-7767" data-mp="2fhudxr2wwqoy">
              <PieChartIcon size={18} className="mr-2 text-blue-400" data-id="element-7768" data-mp="2ffhvzdx5mgbw" />
              Cotizaciones por Producto
            </h3>
            <div className="space-y-4" data-id="element-7769" data-mp="2n0ycyl14a7el">
              {filteredProducts.map(product => <div key={product.product} data-id="element-7770" data-mp="2n3c80tvsrjm5">
                  <div className="flex justify-between items-center mb-1" data-id="element-7771" data-mp="2iyungshm52ab">
                    <div className="text-sm text-blue-200" data-id="element-7772" data-mp="2wzf9rymqlg8k">
                      {product.product}
                    </div>
                    <div className="text-sm text-white" data-id="element-7773" data-mp="2s1m3z6pcio8t">
                      {product.count} cotizaciones ({product.percentage}%)
                    </div>
                  </div>
                  <div className="w-full bg-blue-900/50 rounded-full h-2" data-id="element-7774" data-mp="1zcf2pzyibkjv">
                    <div className={`h-2 rounded-full ${product.product === 'Center Pivots' ? 'bg-blue-500' : product.product === 'Linear Systems' ? 'bg-indigo-500' : product.product === 'Drip Irrigation' ? 'bg-green-500' : product.product === 'Micro Sprinklers' ? 'bg-amber-500' : 'bg-purple-500'}`} style={{
                width: `${product.percentage}%`
              }} data-id="element-7775" data-mp="2e0t6cd3qzd1h"></div>
                  </div>
                </div>)}
            </div>
          </div>}
        {/* Tendencia de Ventas */}
        {visibleSections.salesTrend && <div className="bg-white/10 backdrop-blur-sm rounded-xl border border-blue-800/30 p-5" data-id="element-7776" data-mp="umpbcgy5p1f">
            <div className="flex justify-between items-center mb-4" data-id="element-7777" data-mp="3j8m6y6p9g2ma">
              <h3 className="text-lg font-medium text-white flex items-center" data-id="element-7778" data-mp="3j69l3igdt83y">
                <LineChartIcon size={18} className="mr-2 text-blue-400" data-id="element-7779" data-mp="3n7lb3p363vco" />
                Tendencia de Ventas
              </h3>
              <div className="flex space-x-2" data-id="element-7780" data-mp="jspb7ie775v0">
                <button className="text-xs bg-blue-800/50 hover:bg-blue-800/70 text-blue-200 px-2 py-1 rounded-md" data-id="element-7781" data-mp="jrnwn3xz418j">
                  Semanal
                </button>
                <button className="text-xs bg-blue-600 text-white px-2 py-1 rounded-md" data-id="element-7782" data-mp="arrell63a0mg">
                  Mensual
                </button>
                <button className="text-xs bg-blue-800/50 hover:bg-blue-800/70 text-blue-200 px-2 py-1 rounded-md" data-id="element-7783" data-mp="2qhu8f2kq31vs">
                  Trimestral
                </button>
              </div>
            </div>
            {/* This would be a line chart in a real implementation */}
            <div className="h-64 flex items-end justify-between px-2" data-id="element-7784" data-mp="w487sjwfpqin">
              {data.salesTrend.map(item => <div key={item.month} className="flex flex-col items-center w-1/7" data-id="element-7785" data-mp="rbf4m0gm6q8o">
                  <div className="relative" data-id="element-7786" data-mp="nboe7xv02c4o">
                    <div className="w-12 bg-blue-900/50 rounded-t-md" style={{
                height: `${item.quotes / 400 * 100}%`
              }} data-id="element-7787" data-mp="n8simg6mjzje"></div>
                    <div className="absolute bottom-0 w-12 bg-gradient-to-t from-green-600 to-green-500 rounded-t-md" style={{
                height: `${item.orders / 400 * 100}%`
              }} data-id="element-7788" data-mp="dcfm7ajp37ky"></div>
                  </div>
                  <div className="text-xs text-blue-300 mt-2" data-id="element-7789" data-mp="4dlm3a75nz2n">{item.month}</div>
                </div>)}
            </div>
            <div className="flex justify-center mt-2 space-x-6" data-id="element-7790" data-mp="22pj4fn9vv8ln">
              <div className="flex items-center" data-id="element-7791" data-mp="1yrd3wwzn1p96">
                <div className="w-3 h-3 bg-blue-900/50 mr-2" data-id="element-7792" data-mp="3gnoj29305p37"></div>
                <span className="text-xs text-blue-300" data-id="element-7793" data-mp="3gnet2lhyjhxi">Cotizaciones</span>
              </div>
              <div className="flex items-center" data-id="element-7794" data-mp="3ll6ss1oug8c9">
                <div className="w-3 h-3 bg-green-500 mr-2" data-id="element-7795" data-mp="3qcycbs9l1dsw"></div>
                <span className="text-xs text-blue-300" data-id="element-7796" data-mp="3qfkt8iid55ns">Órdenes</span>
              </div>
            </div>
          </div>}
      </div>
      {/* Modales de filtros - Separados del flujo normal del DOM y con z-index extremadamente alto */}
      {/* Date Picker Modal */}
      {showDatePicker && <div className="fixed inset-0 z-[99999] flex items-start justify-center pt-20" style={{
      backgroundColor: 'rgba(0,0,0,0.5)'
    }} data-id="element-7797" data-mp="32o5q4nirikbh">
          <div className="bg-blue-900 border border-blue-700 rounded-xl shadow-2xl p-4 w-full max-w-md mx-4" onClick={e => e.stopPropagation()} data-id="element-7798" data-mp="3bp3iu9nr35er">
            <div className="mb-3 pb-2 border-b border-blue-800/30 flex justify-between items-center" data-id="element-7799" data-mp="lyqe5eak18tf">
              <span className="text-sm font-medium text-white" data-id="element-7800" data-mp="qwi78bmxr0z7">
                Seleccionar rango de fechas
              </span>
              <button onClick={() => setShowDatePicker(false)} className="text-blue-300 hover:text-white" data-id="element-7801" data-mp="ki2vqx1djsj7">
                <XIcon size={20} data-id="element-7802" data-mp="yhm33nmd2zug" />
              </button>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-7803" data-mp="yfrhs876h5pu">
              <div data-id="element-7804" data-mp="ufhcyyv4glck">
                <label className="block text-xs font-medium text-blue-300 mb-1" data-id="element-7805" data-mp="uez6zainqsrg">
                  Fecha de inicio
                </label>
                <input type="date" value={dateRange.startDate} max={dateRange.endDate} onChange={e => handleDateChange('startDate', e.target.value)} className="w-full bg-blue-800/50 border border-blue-700/40 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-7806" data-mp="13h8dlpat21zk" />
              </div>
              <div data-id="element-7807" data-mp="1r7b789udbg0a">
                <label className="block text-xs font-medium text-blue-300 mb-1" data-id="element-7808" data-mp="1r6szoh299fd2">
                  Fecha de fin
                </label>
                <input type="date" value={dateRange.endDate} min={dateRange.startDate} onChange={e => handleDateChange('endDate', e.target.value)} className="w-full bg-blue-800/50 border border-blue-700/40 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-7809" data-mp="25thyegoonoie" />
              </div>
            </div>
            <div className="mt-4 flex justify-end" data-id="element-7810" data-mp="20skikar5b6k2">
              <button onClick={() => {
            setSelectedDateRange('custom');
            setIsCustomDateRange(true);
            setShowDatePicker(false);
          }} className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors" data-id="element-7811" data-mp="1n30gz89awfcc">
                Aplicar rango
              </button>
            </div>
          </div>
        </div>}
      {/* Manager Selection Modal */}
      {showManagerFilter && <div className="fixed inset-0 z-[99999] flex items-center justify-center" style={{
      backgroundColor: 'rgba(0,0,0,0.5)'
    }} onClick={() => setShowManagerFilter(false)} data-id="element-7812" data-mp="144xqsq50occy">
          <div className="bg-blue-900 border border-blue-700 rounded-xl shadow-2xl p-4 w-full max-w-md mx-4" onClick={e => e.stopPropagation()} data-id="element-7813" data-mp="3aseuno205itu">
            <div className="flex justify-between items-center mb-3 pb-2 border-b border-blue-800" data-id="element-7814" data-mp="3603vinf3612c">
              <span className="text-lg font-medium text-white" data-id="element-7815" data-mp="312lmkx12jluc">
                Seleccionar gerentes de ventas
              </span>
              <button onClick={() => setShowManagerFilter(false)} className="text-blue-300 hover:text-white" data-id="element-7816" data-mp="3tqr5de8kb0rj">
                <XIcon size={20} data-id="element-7817" data-mp="3orekgz1943rl" />
              </button>
            </div>
            <div className="mb-3 flex justify-between items-center" data-id="element-7818" data-mp="3oq3cso4oqbv7">
              <span className="text-sm text-blue-200" data-id="element-7819" data-mp="3korpip9aa2q6">
                {selectedManagers.length} de {filteredSalesManagers.length}{' '}
                seleccionados
              </span>
              <button onClick={() => setSelectedManagers([])} className="text-xs text-blue-300 hover:text-white px-2 py-1 bg-blue-800/50 hover:bg-blue-800/70 rounded-md" data-id="element-7820" data-mp="29bxjhffu46e1">
                Limpiar selección
              </button>
            </div>
            <div className="space-y-1 max-h-60 overflow-y-auto pr-1 mb-3" data-id="element-7821" data-mp="ot4wo55ckzue">
              {filteredSalesManagers.map(manager => <div key={manager.id} className={`flex items-center p-3 hover:bg-blue-800/50 rounded-md cursor-pointer transition-colors ${selectedManagers.includes(manager.id) ? 'bg-blue-800/30' : ''}`} onClick={() => toggleManager(manager.id)} data-id="element-7822" data-mp="suyrhwsv39mn">
                  <div className={`w-8 h-8 rounded-full ${manager.color} flex items-center justify-center text-sm font-medium text-white mr-3`} data-id="element-7823" data-mp="12k073lvhvp03">
                    {manager.avatar}
                  </div>
                  <div className="flex-1" data-id="element-7824" data-mp="1cjhblzz0fwuh">
                    <span className="text-sm text-white font-medium block" data-id="element-7825" data-mp="1gk1d1fqm9mmf">
                      {manager.name}
                    </span>
                    <span className="text-xs text-blue-300" data-id="element-7826" data-mp="3ebnep1lvflx2">
                      {manager.region}
                    </span>
                  </div>
                  <div className="ml-auto" data-id="element-7827" data-mp="2zf5sf2xwn8b5">
                    <div className={`w-6 h-6 rounded-md ${selectedManagers.includes(manager.id) ? 'bg-blue-500 border-blue-500' : 'bg-blue-900/60 border-blue-700/40'} border flex items-center justify-center`} data-id="element-7828" data-mp="2ze4e8plle5p7">
                      {selectedManagers.includes(manager.id) && <CheckIcon size={16} className="text-white" data-id="element-7829" data-mp="346e1fxvborns" />}
                    </div>
                  </div>
                </div>)}
            </div>
            <div className="flex justify-end space-x-2 pt-2 border-t border-blue-800" data-id="element-7830" data-mp="2gh36ix0nlrhk">
              <button onClick={() => setShowManagerFilter(false)} className="px-4 py-2 bg-blue-800/50 hover:bg-blue-800/70 text-blue-200 rounded-lg transition-colors" data-id="element-7831" data-mp="2birx2ne9tizv">
                Cancelar
              </button>
              <button onClick={() => setShowManagerFilter(false)} className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors" data-id="element-7832" data-mp="2kgttsqqz1phc">
                Aplicar filtros
              </button>
            </div>
          </div>
        </div>}
    </div>;
}
function CustomerAnalyticsSection({
  data,
  searchQuery = ''
}) {
  // En una implementación real, aquí filtrarías los datos basados en searchQuery
  return <div className="space-y-6" data-id="element-7833" data-mp="c86z7db0vkkb">
      {/* KPI Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-7834" data-mp="3uhpm0mxpbefp">
        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 border border-blue-800/30" data-id="element-7835" data-mp="3awivdjcl58j">
          <div className="flex items-center justify-between mb-2" data-id="element-7836" data-mp="r0h3s1z2ackg">
            <h3 className="text-blue-300 text-sm font-medium" data-id="element-7837" data-mp="vy985vgw7r5j">
              Total Customers
            </h3>
            <UsersIcon className="text-blue-400" size={20} data-id="element-7838" data-mp="ha4lyhimsxi0" />
          </div>
          <div className="text-3xl font-bold text-white" data-id="element-7839" data-mp="h7s404cvin4y">
            {data.totalCustomers.toLocaleString()}
          </div>
          <div className="flex items-center mt-2 text-sm" data-id="element-7840" data-mp="19xs1vj8yizyb">
            <div className="flex items-center text-green-400" data-id="element-7841" data-mp="19w78vy2ajp2k">
              <ArrowUpIcon size={14} className="mr-1" data-id="element-7842" data-mp="1eps9zyz6kz5z" />
              <span data-id="element-7843" data-mp="2gp142zhx3lms">{data.newCustomersThisMonth} new this month</span>
            </div>
          </div>
        </div>
        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 border border-blue-800/30" data-id="element-7844" data-mp="2lnkmwr17shax">
          <div className="flex items-center justify-between mb-2" data-id="element-7845" data-mp="2qeatu8pags7q">
            <h3 className="text-blue-300 text-sm font-medium" data-id="element-7846" data-mp="2qh6qzutbbcv4">
              Active Customers
            </h3>
            <HeartIcon className="text-green-400" size={20} data-id="element-7847" data-mp="1xq58pkubp17d" />
          </div>
          <div className="text-3xl font-bold text-white" data-id="element-7848" data-mp="1xs9lyte43ckb">
            {data.activeCustomers.toLocaleString()}
          </div>
          <div className="flex items-center mt-2 text-sm" data-id="element-7849" data-mp="27ocpa2kp9h8u">
            <div className="flex items-center text-blue-300" data-id="element-7850" data-mp="27mruqcydxyaz">
              <span data-id="element-7851" data-mp="2bq6k3u87rr13">
                {(data.activeCustomers / data.totalCustomers * 100).toFixed(1)}
                % of total
              </span>
            </div>
          </div>
        </div>
        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 border border-blue-800/30" data-id="element-7852" data-mp="3n4k1cg8gp885">
          <div className="flex items-center justify-between mb-2" data-id="element-7853" data-mp="1bi9j7nod86q1">
            <h3 className="text-blue-300 text-sm font-medium" data-id="element-7854" data-mp="1bjkm7l9zlag3">
              Retention Rate
            </h3>
            <ThumbsUpIcon className="text-amber-400" size={20} data-id="element-7855" data-mp="12pg01f5ssn6w" />
          </div>
          <div className="text-3xl font-bold text-white" data-id="element-7856" data-mp="12nbn67px8duh">
            {data.customerRetentionRate}%
          </div>
          <div className="flex items-center mt-2 text-sm" data-id="element-7857" data-mp="sr8m756t2l94">
            <div className="flex items-center text-blue-300" data-id="element-7858" data-mp="sstgqut4e46z">
              <span data-id="element-7859" data-mp="nrnkwo45y0t8">Year-over-year</span>
            </div>
          </div>
        </div>
        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 border border-blue-800/30" data-id="element-7860" data-mp="jqafug8wa1nd">
          <div className="flex items-center justify-between mb-2" data-id="element-7861" data-mp="erqscbenkhsw">
            <h3 className="text-blue-300 text-sm font-medium" data-id="element-7862" data-mp="etk2w1sdzm66">
              Active Dealers
            </h3>
            <BuildingIcon className="text-purple-400" size={20} data-id="element-7863" data-mp="2e28rspyl9bmy" />
          </div>
          <div className="text-3xl font-bold text-white" data-id="element-7864" data-mp="2969uudz72lax">
            {data.activeDealers}/{data.totalDealers}
          </div>
          <div className="flex items-center mt-2 text-sm" data-id="element-7865" data-mp="2x0tqbfh1sxv7">
            <div className="flex items-center text-blue-300" data-id="element-7866" data-mp="2x2emf9j0gov6">
              <span data-id="element-7867" data-mp="2j9youo8vpj1n">
                {(data.activeDealers / data.totalDealers * 100).toFixed(1)}%
                active
              </span>
            </div>
          </div>
        </div>
      </div>
      {/* ... rest of existing code ... */}
    </div>;
}
function MarketInsightsSection({
  data,
  searchQuery = ''
}) {
  // En una implementación real, aquí filtrarías los datos basados en searchQuery
  return <div className="space-y-6" data-id="element-7868" data-mp="320pubepqwpar">{/* ... existing code ... */}</div>;
}
function QuoteIntelligenceSection({
  searchQuery = ''
}) {
  // En una implementación real, aquí filtrarías los datos basados en searchQuery
  return <div className="flex items-center justify-center h-64 p-6" data-id="element-7869" data-mp="1qjzwaivh73s8">
      {/* ... existing code ... */}
    </div>;
}
function RevenueIntelligenceSection({
  data,
  searchQuery = ''
}) {
  // En una implementación real, aquí filtrarías los datos basados en searchQuery
  return <div className="space-y-6" data-id="element-7870" data-mp="1j1rxyu3zjrkw">{/* ... existing code ... */}</div>;
}
function EngagementSection({
  searchQuery = ''
}) {
  // En una implementación real, aquí filtrarías los datos basados en searchQuery
  return <div className="flex items-center justify-center h-64 p-6" data-id="element-7871" data-mp="1s1oshcd23knv">
      {/* ... existing code ... */}
    </div>;
}
function ExecutiveInsightsSection({
  searchQuery = ''
}) {
  // En una implementación real, aquí filtrarías los datos basados en searchQuery
  return <div className="flex items-center justify-center h-64 p-6" data-id="element-7872" data-mp="108xscqs95btc">
      {/* ... existing code ... */}
    </div>;
}